import { initializeInstances } from "@/init/initializeInstances";
import { Rx } from "./reactive-state-manager";

export class InitializationStateManager {
  //MARK:- Properties
  private static instance: InitializationStateManager;
  private isInProgressInitialization = false;

  public isCompletedInitialization = new Rx<boolean>(false);

  private constructor() {}

  public static getInstance(): InitializationStateManager {
    if (!InitializationStateManager.instance) {
      InitializationStateManager.instance = new InitializationStateManager();
    }
    return InitializationStateManager.instance;
  }

  public async startInitialization() {
    if (this.isInProgressInitialization) {
      return;
    }
    this.isInProgressInitialization = true;

    await initializeInstances();
    InitializationStateManager.getInstance().isCompletedInitialization.set(true);
  }
}
